import _objectSpread from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
export default {
  name: 'BasicLayout',
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['keepAliveArrs', 'getForwardPage'])), {}, {
    hasTabBar: function hasTabBar() {
      return this.$route.meta.hasTabBar;
    },
    hasNoHead: function hasNoHead() {
      if (this.$route.meta && this.$route.meta.hasAppHead) {
        return false;
      } else {
        // 如果是app通过forward页面打开的不隐藏头
        if (this.getForwardPage && this.$Utils.appInfo) {
          return false;
        }

        return !!(this.$route.meta.hasNoHead || this.$Utils.appInfo);
      }
    }
  })
};